// eslint-disable-next-line import/prefer-default-export
export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
